import { useQuery } from "@tanstack/react-query";
import { clubApi } from "../../club-api-client";
import { queryKeys } from "../query-keys";

/**
 * Rolling training feedback for every group the caller may read.
 *
 * No retry: a caller without the right club role gets a 403, and that answer is
 * final — retrying it only delays the "you cannot see this" the UI needs. It
 * doubles as the portal's access check, since the API is the only thing that
 * knows the caller's club role.
 */
export function useSquadRatings(clubId: string | null) {
	return useQuery({
		enabled: !!clubId,
		queryFn: () => clubApi.ratings.listForClub(clubId!),
		queryKey: queryKeys.clubPortal.squadRatings(clubId ?? ""),
		retry: false,
	});
}
